import { Link } from 'react-router-dom';

export interface IDataTableNotFoundSectionProps {
  title?: string;
  description?: string;

  actionBtn?: {
    label: string;
    slug?: string;
    onClick?: () => void;
  };
}

export default function DataTableNotFoundSection(props: IDataTableNotFoundSectionProps) {
  const { title = 'Aradığınız özelliklere veri bulunamadı.', description = 'Lütfen farklı bir filtreleme yapınız veya veri eklemeyi deneyiniz.', actionBtn } = props;
  const { label, slug, onClick } = actionBtn || {};

  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-4 pb-8">
      <img
        className="mb-4"
        loading="lazy"
        src="/media/illustrations/not-found.svg"
        alt="Not found"
        style={{
          width: 200,
          height: 200,
          objectFit: 'contain',
          objectPosition: 'center',
        }}
      />

      <div className="d-flex flex-column align-items-center justify-content-center gap-2">
        <h3 className="fw-bolder fs-3 text-gray-800">{title}</h3>
        <p className="text-gray-600 fs-6">{description}</p>
      </div>

      {slug || onClick ? (
        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
          {onClick ? (
            <button className="btn btn-primary" onClick={onClick}>
              {label}
            </button>
          ) : slug ? (
            <Link to={slug} className="btn btn-primary">
              {label}
            </Link>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
